import { render } from "./MySwiper.vue?vue&type=template&id=7809464b&scoped=true"
import script from "./MySwiper.vue?vue&type=script&lang=js"
export * from "./MySwiper.vue?vue&type=script&lang=js"

import "./MySwiper.vue?vue&type=style&index=0&id=7809464b&lang=scss&scoped=true"

import exportComponent from "/Users/jiangxin/xhw/outer-h5-gwj-nft-website-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7809464b"]])

export default __exports__